import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem, Chip, Stack} from '@mui/material';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ButtonWrapper = styled.div`
  display: flex;
`


const OTEditableRow = ({k,row, editFormData, handleCancelClick, offices,
   page, rowsPerPage, onChangeEditOffice, officetype, SubmitButton, tableFontSize}) =>{
    return( 
      <>
        <TableRow key={k} name={row.Category}>
          <TableCell component="th" scope="row" sx={{ fontSize: tableFontSize}}>
           {(page)*(rowsPerPage)+k+1}
          </TableCell>
           
          <TableCell sx={{ fontSize: tableFontSize}}  align="left">
            <TextField
                id="outlined-basic"
                size='small'
                type="text"
                name={`name${(page)*(rowsPerPage)+k}`}
                onChange={(event, newValue) => onChangeEditOffice(event, newValue)}
                label="Office"
                value={editFormData[`name${(page)*(rowsPerPage)+k}`]}
                variant="outlined"
                sx={{backgroundColor:"white", width:"200px", height:"40px"}}
              />          
          </TableCell>

          <TableCell sx={{ fontSize: tableFontSize}}  align="left">
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              size='small'
              value={editFormData[`type${(page)*(rowsPerPage)+k}`]}
              onChange={(event, newValue) => onChangeEditOffice(event, newValue, `type${(page)*(rowsPerPage)+k}`)}
              options={Object.values(officetype).sort((a,b)=>{
                //We are using sort Algorithm to sort the Office types based on Level.
                let numA = parseInt(a.level.match(/\d+/)[0]);
                let numB = parseInt(b.level.match(/\d+/)[0]);                  
                return numA - numB;
                }).map(x=>x.type)
              }
              sx={{backgroundColor:"white", width:"150px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
              renderInput={(params) => <TextField {...params} label={"Office Type"} />}
            />         
          </TableCell>

          <TableCell sx={{ fontSize: tableFontSize}}  align="left">
            {Object.values(officetype)?.find(x => x.type === editFormData[`type${(page)*(rowsPerPage)+k}`])?.level}                
          </TableCell>

          <TableCell sx={{ fontSize: tableFontSize}}  align="left">
            {((page)*(rowsPerPage)+k === 0)?"Not Applicable":
              (<Autocomplete
                disablePortal
                id="combo-box-demo"
                size='small'
                value={editFormData[`superioroffice${(page)*(rowsPerPage)+k}`]}
                onChange={(event, newValue) => onChangeEditOffice(event, newValue, `superioroffice${(page)*(rowsPerPage)+k}`)}
                options={Object.values(offices).filter(x => parseInt(x?.level?.slice(-1)) < parseInt(Object.values(officetype)?.find(x => x.type === editFormData[`type${(page)*(rowsPerPage)+k}`])?.level.slice(-1))).map(x=>x.name)}
                sx={{backgroundColor:"white", width:"200px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
                renderInput={(params) => <TextField {...params} label={"Superior Office"} />}
              />)}
          </TableCell>

          <TableCell sx={{ fontSize: tableFontSize}}   align="left">
          {row?.unitHead?.length? row?.unitHead: "Not Available" }
         </TableCell>

            <TableCell sx={{ fontSize: tableFontSize}}  align="left">
          {row?.bo?.length? row?.bo: "Not Available"}
         </TableCell>                     

        <TableCell sx={{ fontSize: tableFontSize}}  align="left">
          <ButtonWrapper>
            <SubmitButton style={{marginRight:'10px'}} type="submit">Save</SubmitButton>
            <SubmitButton style={{marginRight:'10px'}} type="button" onClick={(e)=>handleCancelClick(e,k)}
            >Cancel</SubmitButton>
          </ButtonWrapper>                          
        </TableCell>
      </TableRow>     
    </>         
    )
}

export default OTEditableRow;